import {EGiftCertificateType, GiftCertificateItem} from 'coreStore/data/basket/types';
import LineItemModel from './LineItemModel';

/**
 * Represents an order gift certificate item
 */
abstract class GiftCertificateItemModel extends LineItemModel {

	/**
	 * @constructor
	 * @param {GiftCertificateItem} giftCertificateItem - The gift certificate item
	 */
	constructor(giftCertificateItem: GiftCertificateItem) {
		super(giftCertificateItem);
	}

	/**
	 * Returns the item id
	 * @returns {string} item id
	 */
	getItemId(): string {
		return (this.item as GiftCertificateItem).giftCertificateItemId;
	}

	/**
	 * Returns the item recipient email
	 * @returns {string} item
	 */
	getRecipientEmail(): string {
		return (this.item as GiftCertificateItem).recipientEmail;
	}
	/**
	 * Returns the item recipient name
	 * @returns {string} item
	 */
	getRecipientName(): string {
		return (this.item as GiftCertificateItem).recipientName;
	}
	/**
	 * Returns the item sender name
	 * @returns {string} item
	 */
	getSenderName(): string {
		return (this.item as GiftCertificateItem).senderName;
	}
	/**
	 * Returns the item delay dispatch date custom attribute
	 * @returns {Date} item
	 */
	getDelayDispatchDate(): Date {
		return (this.item as GiftCertificateItem).c_delayDispatchDate
			? new Date((this.item as GiftCertificateItem).c_delayDispatchDate)
			: null;
	}

	/**
	 * Returns the gift certificate type custom attribute
	 * @returns {EGiftCertificateType} item gift certificate type
	 */
	getGiftCertificateType(): EGiftCertificateType {
		return (this.item as GiftCertificateItem).c_giftCertificateType;
	}

	/**
	 * Returns the item sender email custom attribute
	 * @returns {string} item sender email
	 */
	getSenderEmail(): string {
		return (this.item as GiftCertificateItem).c_senderEmail;
	}

	/**
	 * Returns the gift certificate item message
	 * @returns {string} item message
	 */
	getMessage(): string {
		return (this.item as GiftCertificateItem).message;
	}

	/**
	 * Returns the item amount
	 * @returns {number} item amount
	 */
	getPrice(): number {
		return (this.item as GiftCertificateItem).amount;
	}

	/**
	 * Returns quantity of certificates
	 * @returns {number} quantity
	 */
	getQuantity(): number {
		return 1;
	}
}

export default GiftCertificateItemModel;
